export default __webpack_public_path__ + "b8c0a06f36e4935a77f8e46b34590d21.svg";